type Page = {
  type: 'number';
  value: number;
};

type Ellipsis = {
  type: 'ellipsis';
};

export type PaginationElement = Page | Ellipsis;

export function getPaginationElements({
  currentPage,
  totalPages,
  maxVisibleElements,
}: {
  currentPage: number;
  totalPages: number;
  maxVisibleElements: number;
}): PaginationElement[] {
  const result: PaginationElement[] = [];
  const addNumber = (num: number) =>
    result.push({ type: 'number', value: num });
  const addEllipsis = () => result.push({ type: 'ellipsis' });

  const start = Math.max(
    1,
    Math.min(
      currentPage - Math.floor((maxVisibleElements - 3) / 2),
      totalPages - maxVisibleElements + 2
    )
  );
  const end = Math.min(
    totalPages,
    Math.max(
      currentPage + Math.floor((maxVisibleElements - 2) / 2),
      maxVisibleElements - 1
    )
  );

  if (start > 1) {
    addNumber(1);
    if (start > 2) {
      addEllipsis();
    }
  }
  for (let i = start; i <= end; i++) {
    addNumber(i);
  }
  if (end < totalPages) {
    if (end < totalPages - 1) {
      addEllipsis();
    }
    addNumber(totalPages);
  }

  return result;
}
